





























import { Component, Vue, Prop, Ref } from "vue-property-decorator";

@Component
export default class FormImageUpload extends Vue {
  @Ref("fileUpload") readonly fileUpload!: HTMLInputElement;

  @Prop({ required: true }) value!: ArrayBuffer | null;
  @Prop() previewImage!: string | null;

  uploading: boolean = false;

  clickFileUpload() {
    this.fileUpload.click();
  }

  clearFile() {
    //@ts-ignore
    this.fileUpload.value = "";
  }

  async onFileChange(e: Event) {
    const files = (e.target as HTMLInputElement).files;

    if (!files) {
      return;
    }

    if (files[0].type !== "image/png") {
      return;
    }

    this.uploading = true;

    this.$emit("input", files[0]);

    setTimeout(() => {
      this.uploading = false;
    }, 500);
  }
}
